import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, Megaphone, Award, DollarSign } from "lucide-react";

const ICONS = { broadcast: Megaphone, info: Bell };

export default function Notifications() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
    api.post("/notifications/read").catch(() => {});
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2"><Bell className="w-6 h-6 text-jixxeo-green" /><h2 className="font-head font-extrabold text-xl">Notifications</h2></div>
      {items.length === 0 ? (
        <div className="glass rounded-2xl p-8 text-center text-muted-foreground"><Bell className="w-10 h-10 mx-auto mb-2 opacity-40" />You're all caught up!</div>
      ) : (
        <div className="space-y-2">
          {items.map((n) => {
            const I = ICONS[n.kind] || Bell;
            return (
              <div key={n.id} className={`glass rounded-2xl p-4 flex gap-3 ${!n.read ? "border border-jixxeo-green/30" : ""}`} data-testid={`notif-${n.id}`}>
                <div className="w-9 h-9 rounded-full bg-jixxeo-green/15 flex items-center justify-center shrink-0"><I className="w-4 h-4 text-jixxeo-green" /></div>
                <div className="flex-1"><p className="font-bold text-sm">{n.title}</p><p className="text-xs text-muted-foreground">{n.body}</p>
                  <p className="text-[10px] text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString()}</p></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
